// extracted by mini-css-extract-plugin
export default {"flexSpacer":"FooterButtons-module__flexSpacer","resetButton":"FooterButtons-module__resetButton","cancelButton":"FooterButtons-module__cancelButton"};